import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { AUTHENTICATED_ENTRY, NO_PACKAGE_ENTRY } from "configs/AppConfig";

const PublicRoute = () => {
  const { token } = useSelector((state) => state.auth);
  const user = JSON.parse(localStorage.getItem("auth_user"));
  const { vendorCategories } = useSelector((state) => state.auth);
  console.log("entered to public route", user, token);
  console.log("major condition", vendorCategories);

  return token &&
    vendorCategories?.length == 0 ? (   //real checking for vendor categories length
    <Navigate to={NO_PACKAGE_ENTRY} /> //to go to no package page when no package for vendor
  ) : (
    <Outlet />
  );
};

export default PublicRoute;
